import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-623fea4f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Logout", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Are you sure you want to logout?", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Yes", -1))
const _hoisted_5 = [
  _hoisted_4
]

import { ref } from "vue";
import { useRouter } from "vue-router";
import Modal from "@/components/Modal.vue";
import Exit from "@/components/svgs/Exit.vue";

import { showLogoutModal, logout } from "@/refs/account";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'LogoutModal',
  setup(__props) {

const tryLogout = () => {
	logout();
	showLogoutModal.value = false;
	router.push("/");
};

return (_ctx: any,_cache: any) => {
  return (_unref(showLogoutModal))
    ? (_openBlock(), _createBlock(Modal, { key: 0 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("span", {
              class: "exit",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showLogoutModal.value = false))
            }, [
              _createVNode(Exit)
            ])
          ]),
          _hoisted_3,
          _createElementVNode("button", { onClick: tryLogout }, _hoisted_5)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})